import React from 'react'

import { Switch } from '@fourthwall/components'
import { useAdminModeContext } from '@modules/App/providers/AdminModeProvider'

import * as S from './styled'

export const AdminModeSwitch = () => {
  const adminMode = useAdminModeContext()

  if (!adminMode || !adminMode.isInternalAdmin) return null

  return (
    <S.Container>
      <Switch
        side="right"
        size="small"
        label="Admin mode"
        value={adminMode.isActive}
        onChange={adminMode.toggleActive}
      />
    </S.Container>
  )
}
